export enum DivisionTypeEnum {
Apartment = 'APARTMENT',
House = 'HOUSE',
Warehouse = 'WAREHOUSE',
Hotel = 'HOTEL',
Slab = 'SLAB',
Allotment = 'ALLOTMENT',
Mall = 'MALL',
Rural = 'RURAL',
Salon = 'SALON',
Land = 'LAND',
Office = 'OFFICE',
ParkingLot = 'PARKING_LOT',
Flat = 'FLAT'
}
